import script from "./BackgroundUI.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundUI.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundUI.vue?vue&type=style&index=0&id=0a68f0a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a68f0a6"]])

export default __exports__